<template>
  <!-- 咨询订单列表 -->
  <div v-if="bodyShow" class="experience-list">
    <!-- 职业经历 -->
    <div class="experience-box">
      <div class="head">
        <div class="bdr"></div>
        职业经历<span>让咨询师更了解你</span>
        <img @click="addExperience()" class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/ex_add.png" alt="">
      </div>
      <div @click="toEditExperience(index)" v-for="(item,index) in list" :key="index" class="content">
        <div class="row">
          <span class="title">{{item.corporate_name}}</span>
          <img class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
        </div>
        <div class="row">
          <span class="text">{{item.industry}}</span>
          <span class="text on">{{item.profession}}</span>
          <span v-if="item.time.length>=2" class="right">{{item.time[0]}}-{{item.time[1]}}</span>
        </div>
        <!--  -->
        <div class="ctx-text">
          {{item.job_content}}
        </div>
      </div>
    </div>
    <!-- 咨询经历 -->
    <div class="experience-box">
      <div class="head">
        <div class="bdr"></div>
        <div class="text">近期是否有过相关问题的咨询经历，如果有，情况如何？</div>
        <img class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/ex_edit.png" alt="">
      </div>
      <div  class="content">
        <!--  -->
        <div class="ctx-text">
          我有一只小毛驴我从来也不骑，有一天我心血来潮骑着去赶集，我手里拿着小皮鞭我心里正得意，不知怎么哗啦啦啦我摔了一身泥。
          我有一只小毛驴我从来也不骑，有一天我心血来潮骑着去赶集，我手里拿着小皮鞭我心里正得意，不知怎么哗啦啦啦我摔了一身泥。
        </div>
      </div>
    </div>
    <!-- 咨询经历 -->
    <div class="experience-box">
      <div class="head">
        <div class="bdr"></div>
        <div class="text">重要他人（家人、朋友等）对自己的期望和影响？</div>
        <img class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/ex_edit.png" alt="">
      </div>
      <div  class="content">
        <!--  -->
        <div class="ctx-text">
          <!-- {{item.job_content}} -->
          <div class="ex-no">
            <img class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/ex_no.png" alt="">
            <p>还未填写内容哦</p>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="footer">
        <button @click="nextStep()">下一步</button>
    </div>
  </div>
</template>

<script>
import { orderGet, saveInfo } from "@/api/xuandui_gadgets";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
export default {
  data() {
    return {
      bodyShow:false,
      times:[],
      keys:{
          corporate_name:'公司名称',
          profession:'职业类型',
          industry:'所在行业',
          job_content:'工作内容'
      },
      form:{
          corporate_name:'',
          profession:'',
          industry:'',
          job_content:''
      },
      list:[],
      item:[]
    }
  },
  methods: {
    // 下一步
    nextStep(){
      this.$router.push('/xd_ef');
    },
    // 编辑职业经历
    toEditExperience(idx){
      this.$router.push({
        path:'/xd_add_experience',
        query:{
          oid:this.item.id,
          eidx:idx
        }
      });
    },
    // 添加职业经历
    addExperience(){
      this.$router.push({
        path:'/xd_add_experience',
        query:{
          oid:this.item.id
        }
      });
    },
    // 初始化获取数据
    pullData() {
      //调用加载中
      this.$emit("loadingHandle", true, "拼命加载中...");
      let q = this.$route.query;
      let obj = {
        id: q.oid,
      };
      orderGet(obj).then((data) => {
        //关闭加载中
        this.$emit("loadingHandle", false);
        if (data.error > 0) {
          this.$toast(data.detail || data.msg);
          return;
        }
        this.item = data.item;
        // 获取已填写的信息
        let arr  = [];
        let info = JSON.parse(data.item.collection)? JSON.parse(data.item.collection) : [];
        
        let form = {};
        let keys_ = Object.keys(this.keys);
        if (info[0]) {
          info[0].value.map((valItem, valIdx) => {
            valItem.map((v, idx) => {
              keys_.map((k, kidx) => {
                // 时间
                if (v.label == "时间") {
                  form['time'] = v.value.split("^");
                } else {
                  if (v.label == this.keys[k]) {
                    form[k] = v.value;
                  }
                }
              });
            });
            arr.push(deepCopy(form));
          });
        }
        this.list = arr;
        this.bodyShow = true;

        
      });

      document.title = "咨询订单";
      shareCon("index", this);
    },
  },
  created() {
    this.pullData();
  },
};
</script>

<style lang="scss" scoped>
.experience-list{
  padding: 0 30px 150px;
  background-color: #ffffff;
  .experience-box{
    margin-bottom: 20px;
    &:last-of-type{
      margin-bottom: 0;
    }
    .head{
      display: flex;
      font-size: 32px;
      color: #2B333A;
      padding: 26px 0;
      .bdr{
        width: 6px;
        height: 30px;
        background: #46A3FA;
        border-radius: 6px;
        margin-right: 20px;
        margin-top: 6px;
      }
      .text{
        width: 580px;
        line-height: 46px;
      }
      span{
        font-size: 24px;
        color: #A9AFB3;
        margin-left: 10px;
        line-height: 46px;
      }
      .icon{
        width: 44px;
        height: 44px;
        margin-left: auto;
      }

    }
    .content{
      background-color: #F7F8F9;
      border-radius: 20px;
      padding: 30px;
      margin-bottom: 20px;
      &:last-of-type{
        margin-bottom: 0;
      }
      .row{
        display: flex;
        align-items: center;
        .title{
          font-size: 30px;
          color: #2B333A;
          line-height: 46px;
          margin-bottom: 10px;
        }
        .text{
          font-size: 24px;
          color: #A9AFB3;
          line-height: 46px;
        }
        .text.on{
          margin-left: 20px;
        }
        .icon{
          margin-left: auto;
        }
        .right{
          font-size: 24px;
          color: #A9AFB3;
          margin-left: auto;
        }
      }
      .ctx-text{
        color: #7D8289;
        font-size: 28px;
        margin-top: 20px;
        display: flex;
        .ex-no{
          margin: auto;
          text-align: center;
          .icon{
            width: 104px;
          }
          p{
            font-size: 24px;
            font-weight: 400;
            color: #A9AFB3;
            line-height: 46px;
          }
        }
      }
    }
  }
  .footer{
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 750px;
    background-color: #FFFFFF;
    button{
        width: 670px;
        height: 80px;
        background: #46A3FA;
        border-radius: 40px;
        font-size: 32px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 44px;
        letter-spacing: 1px;
        border: none;
    }
  }
}
</style>